<template>
  <div class="spinner-container">
    <b-spinner class="spinner"></b-spinner>
  </div>
</template>

<script>
export default {
  name: "gyra-spinner"
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70vh;
}
.spinner {
  color: $gyra-salmon;
}
</style>
